<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>

    <a-spin :spinning="loading">
      <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">

        <!-- 基本信息 -->
        <a-divider orientation="left">基本信息</a-divider>

        <a-form-model-item label="优惠券名称" prop="couponName">
          <a-input v-model="form.couponName" :maxLength="50" placeholder="请输入优惠券名称" />
        </a-form-model-item>

<!--        <a-form-model-item label="优惠券类型" prop="couponType">-->
<!--          <a-radio-group v-model="form.couponType" @change="handleCouponTypeChange">-->
<!--            <a-radio :value="1">满减券</a-radio>-->
<!--            <a-radio :value="2">折扣券</a-radio>-->
<!--          </a-radio-group>-->
<!--          <a-alert v-if="form.couponType === 1" message="满减券:满足指定金额后减免指定金额" type="info" show-icon style="margin-top: 8px;" />-->
<!--          <a-alert v-if="form.couponType === 2" message="折扣券:享受指定折扣(如8折输入8)" type="info" show-icon style="margin-top: 8px;" />-->
<!--        </a-form-model-item>-->

        <!-- 满减券设置 -->
        <template v-if="form.couponType === 1">
          <a-form-model-item label="减免金额" prop="money">
            <a-input-number
              v-model="form.money"
              :min="0.01"
              :max="999999"
              :precision="2"
              placeholder="请输入减免金额"
              style="width: 200px;"
            />
            <span style="margin-left: 8px;">元</span>
          </a-form-model-item>
        </template>

        <!-- 折扣券设置 -->
        <template v-if="form.couponType === 2">
          <a-form-model-item label="折扣" prop="discount">
            <a-input-number
              v-model="form.discount"
              :min="0.1"
              :max="9.9"
              :precision="1"
              placeholder="请输入折扣,如8折输入8"
              style="width: 200px;"
            />
            <span style="margin-left: 8px;">折</span>
            <a-alert message="折扣范围:0.1-9.9折,例如8折请输入8" type="warning" show-icon style="margin-top: 8px;" />
          </a-form-model-item>
        </template>

        <!-- 消费门槛 -->
        <a-form-model-item label="使用门槛" prop="atLeast">
          <a-input-number
            v-model="form.atLeast"
            :min="0"
            :max="999999"
            :precision="2"
            placeholder="0表示无门槛"
            style="width: 200px;"
          />
          <span style="margin-left: 8px;">元 (0表示无门槛)</span>
        </a-form-model-item>

        <a-form-model-item label="发放数量" prop="count">
          <a-input-number
            v-model="form.count"
            :min="1"
            :max="999999"
            :precision="0"
            placeholder="请输入发放数量"
            style="width: 200px;"
          />
        </a-form-model-item>

        <a-form-model-item label="每人限领" prop="maxFetch">
          <a-input-number
            v-model="form.maxFetch"
            :min="0"
            :max="999"
            :precision="0"
            placeholder="0表示不限制"
            style="width: 200px;"
          />
          <span style="margin-left: 8px;">张 (0表示不限制)</span>
        </a-form-model-item>

        <!-- 有效期设置 -->
        <a-divider orientation="left">有效期设置</a-divider>

        <a-form-model-item label="有效期类型" prop="validType">
          <a-radio-group v-model="form.validType" @change="handleValidTypeChange">
            <a-radio :value="1">固定日期</a-radio>
            <a-radio :value="2">领取后有效天数</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item v-if="form.validType === 1" label="开始时间" prop="startTime">
          <a-date-picker
            v-model="form.startTime"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择开始时间"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item v-if="form.validType === 1" label="结束时间" prop="endTime">
          <a-date-picker
            v-model="form.endTime"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择结束时间"
            style="width: 100%"
          />
        </a-form-model-item>

        <a-form-model-item v-if="form.validType === 2" label="有效天数" prop="validDays">
          <a-input-number
            v-model="form.validDays"
            :min="1"
            :max="365"
            :precision="0"
            placeholder="领取后有效天数"
            style="width: 200px;"
          />
          <span style="margin-left: 8px;">天</span>
        </a-form-model-item>

        <!-- 适用门店设置 -->
        <a-divider orientation="left">适用门店设置</a-divider>

        <a-form-model-item label="适用门店" prop="shopIds">
          <a-select
            v-model="form.shopIds"
            mode="multiple"
            placeholder="请选择适用门店(可多选)"
            style="width: 100%"
            @change="handleShopChange"
          >
            <a-select-option v-for="shop in shopList" :key="shop.id" :value="shop.id">
              {{ shop.shopName }}
            </a-select-option>
          </a-select>
<!--          <span style="color: #999; font-size: 12px;">不选择则适用于所有门店</span>-->
        </a-form-model-item>

        <!-- 使用范围设置 -->
        <a-divider orientation="left">使用范围设置</a-divider>

        <a-form-model-item label="适用范围" prop="rangeType">
          <a-select v-model="form.rangeType" placeholder="请选择适用范围" @change="handleRangeTypeChange">
            <a-select-option :value="1">全场通用</a-select-option>
            <a-select-option :value="2">指定分类</a-select-option>
            <a-select-option :value="3">指定商品</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item v-if="form.rangeType === 2" label="选择分类" prop="businessId">
          <a-tree-select
            v-model="form.businessId"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="cateOptions"
            placeholder="请选择商品分类"
            :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
            tree-default-expand-all
            allow-clear
          />
        </a-form-model-item>

        <a-form-model-item v-if="form.rangeType === 3" label="选择商品" prop="businessId">
          <a-button type="dashed" @click="openGoodsSelect">
            <span style="color: dodgerblue">选择商品</span>
          </a-button>
          <a-alert v-if="form.goodsList.length > 0" :message="`已选择 ${form.goodsList.length} 个商品`" type="success" style="margin-top: 8px;" />
        </a-form-model-item>

        <!-- 商品列表展示 -->
        <a-table
          v-if="form.rangeType === 3 && form.goodsList.length > 0"
          rowKey="id"
          :size="tableSize"
          :columns="goodsColumns"
          :data-source="form.goodsList"
          :pagination="false"
          :bordered="tableBordered"
          style="margin-bottom: 20px"
        >
          <template slot="picture" slot-scope="text, record">
            <img v-if="record.picture" :src="record.picture" style="width:60px;height:60px;" @click="handlePreview(record.picture)" alt="商品图片"/>
          </template>
        </a-table>



        <!-- 用户限制设置 -->
        <a-divider orientation="left">用户限制设置</a-divider>

        <a-form-model-item label="发放类型" prop="isNewCoupon">
          <a-radio-group v-model="form.isNewCoupon">
            <a-radio :value="0">普通优惠券</a-radio>
            <a-radio :value="1">新人优惠券</a-radio>
            <a-radio :value="2">直播优惠券</a-radio>
          </a-radio-group>
          <a-alert v-if="form.isNewCoupon === 1" message="新人优惠券仅限新注册用户领取一次" type="info" show-icon style="margin-top: 8px;" />
          <a-alert v-if="form.isNewCoupon === 2" message="直播优惠券仅限直播间领取" type="info" show-icon style="margin-top: 8px;" />
        </a-form-model-item>

        <a-form-model-item label="会员等级限制" prop="needUserLevel">
          <a-select
            v-model="form.needUserLevel"
            mode="multiple"
            placeholder="不选则所有会员等级都可领取"
            allow-clear
            style="width: 100%"
          >
            <a-select-option v-for="item in levelList" :key="item.level" :value="item.level">
              {{ item.levelName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="是否显示在首页" prop="isShow">
          <a-switch v-model="form.isShow" checked-children="显示" un-checked-children="隐藏" />
        </a-form-model-item>

        <a-form-model-item label="优惠券说明" prop="detailMessage">
          <a-textarea
            v-model="form.detailMessage"
            :maxLength="500"
            placeholder="请输入优惠券使用说明"
            :rows="4"
            show-word-limit
          />
        </a-form-model-item>

        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm">
              保存
            </a-button>
            <a-button @click="onClose">
              取消
            </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-spin>

    <!-- 图片预览 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="preview" style="width: 100%" :src="previewImage" />
    </a-modal>

    <!-- 商品选择组件 -->
    <radio-goods-select-form ref="RadioGoodsSelectForm" @goodsSelect="handleGoodsSelect" />
  </a-drawer>
</template>

<script>
import { getCouponType, addCouponType, updateCouponType } from '@/api/coupon/couponType'
import { mapGetters } from 'vuex'
import RadioGoodsSelectForm from '@/views/goods/goods/modules/RadioSelectForm'
import { listCategory } from '@/api/goods/category'
import { listShop } from '@/api/shop/shop'
import { listAll } from '@/api/plus/plusLevel'

export default {
  name: 'EnhancedCouponForm',
  components: {
    RadioGoodsSelectForm
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      open: false,
      formTitle: '',
      previewVisible: false,
      previewImage: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      formType: 1,
      shopList: [],
      cateOptions: [],
      levelList: [],
      goodsColumns: [
        {
          title: '商品名称',
          dataIndex: 'goodsName',
          width: 200,
          ellipsis: true
        },
        {
          title: '商品图片',
          dataIndex: 'picture',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'picture' }
        },
        {
          title: '商品价',
          dataIndex: 'price',
          width: 100,
          align: 'center'
        }
      ],
      form: {
        id: null,
        couponName: null,
        couponType: 1, // 1满减券 2折扣券
        money: null,
        discount: null,
        atLeast: 0,
        count: 100,
        maxFetch: 1,
        validType: 1, // 1固定日期 2领取后有效天数
        startTime: null,
        endTime: null,
        validDays: 30,
        rangeType: 1, // 1全场 2分类 3商品
        businessId: null,
        shopIds: [],
        isNewCoupon: 0, // 0普通 1新人 2直播
        needUserLevel: [],
        isShow: true,
        detailMessage: null,
        goodsList: []
      },
      rules: {
        couponName: [
          { required: true, message: '优惠券名称不能为空', trigger: 'blur' }
        ],
        couponType: [
          { required: true, message: '请选择优惠券类型', trigger: 'change' }
        ],
        money: [
          { required: true, message: '减免金额不能为空', trigger: 'blur' }
        ],
        discount: [
          { required: true, message: '折扣不能为空', trigger: 'blur' }
        ],
        atLeast: [
          { required: true, message: '使用门槛不能为空', trigger: 'blur' }
        ],
        count: [
          { required: true, message: '发放数量不能为空', trigger: 'blur' }
        ],
        maxFetch: [
          { required: true, message: '每人限领不能为空', trigger: 'blur' }
        ],
        validType: [
          { required: true, message: '请选择有效期类型', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' }
        ],
        validDays: [
          { required: true, message: '有效天数不能为空', trigger: 'blur' }
        ],
        rangeType: [
          { required: true, message: '请选择适用范围', trigger: 'change' }
        ],
        businessId: [
          { required: true, message: '请选择分类或商品', trigger: 'change' }
        ],
        isNewCoupon: [
          { required: true, message: '请选择发放类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['tableSize', 'tableBordered'])
  },
  created() {
    this.getCateList()
    this.getShopList()
    this.getLevelList()
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      // 如果已经是字符串格式 YYYY-MM-DD，直接返回
      if (typeof date === 'string' && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return date
      }
      // 如果是日期对象或带时间的字符串，格式化为 YYYY-MM-DD
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    handlePreview(url) {
      this.previewImage = url
      this.previewVisible = true
    },
    onClose() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        couponName: null,
        couponType: 1,
        money: null,
        discount: null,
        atLeast: 0,
        count: 100,
        maxFetch: 1,
        validType: 1,
        startTime: null,
        endTime: null,
        validDays: 30,
        rangeType: 1,
        businessId: null,
        shopIds: [],
        isNewCoupon: 0,
        needUserLevel: [],
        isShow: true,
        detailMessage: null,
        goodsList: []
      }
    },
    getCateList() {
      listCategory().then(response => {
        this.cateOptions = response.data
      })
    },
    getShopList() {
      listShop({}).then(response => {
        this.shopList = (response.data || []).filter(shop => shop.shopType === 3)
      })
    },
    getLevelList() {
      listAll().then(response => {
        if (response.code == 20001) {
          this.levelList = response.data || []
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增优惠券'
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      this.formTitle = '修改优惠券'

      if (row && row.id) {
        this.loading = true
        getCouponType({ id: row.id }).then(response => {
          const data = response.data
          console.log('优惠券详情数据:', data)
          console.log('优惠券 rangeType:', data.rangeType)
          console.log('优惠券 businessId:', data.businessId)
          console.log('商品列表:', data.goodsList)
          console.log('商品列表长度:', data.goodsList ? data.goodsList.length : 0)
          this.form = {
            id: data.id,
            couponName: data.couponName,
            couponType: data.couponType || 1,
            money: data.money,
            discount: data.discount,
            atLeast: data.atLeast,
            count: data.count,
            maxFetch: data.maxFetch,
            validType: data.validType || 1,
            startTime: data.startTime ? this.formatDate(data.startTime) : null,
            endTime: data.endTime ? this.formatDate(data.endTime) : null,
            validDays: data.validDays || 30,
            rangeType: data.rangeType,
            businessId: data.businessId,
            shopIds: data.shopIds ? data.shopIds.split(',') : [],
            isNewCoupon: data.isNewCoupon || 0,
            needUserLevel: data.needUserLevel ? data.needUserLevel.split(',').map(Number) : [],
            isShow: data.isShow,
            detailMessage: data.detailMessage,
            goodsList: data.goodsList || []
          }
          console.log('表单数据 goodsList:', this.form.goodsList)
          this.open = true
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    handleCouponTypeChange() {
      // 切换优惠券类型时清空对应字段
      if (this.form.couponType === 1) {
        this.form.discount = null
      } else {
        this.form.money = null
      }
    },
    handleValidTypeChange() {
      // 切换有效期类型时清空对应字段
      if (this.form.validType === 1) {
        this.form.validDays = null
      } else {
        this.form.startTime = null
        this.form.endTime = null
      }
    },
    handleRangeTypeChange() {
      // 切换适用范围时清空对应字段
      this.form.businessId = null
      this.form.goodsList = []
    },
    handleShopChange() {
      // 切换门店时清空已选择的商品
      if (this.form.rangeType === 3) {
        this.form.goodsList = []
        this.form.businessId = null
      }
    },
    openGoodsSelect() {
      if (!this.form.shopIds || this.form.shopIds.length === 0) {
        this.$message.error('请先选择适用门店')
        return
      }
      // 使用第一个选中的门店
      this.$refs.RadioGoodsSelectForm.openGoods(this.form.shopIds[0], this.form.goodsList.map(item => item.id))
    },
    handleGoodsSelect(records) {
      this.form.goodsList = records
      this.form.businessId = records.map(item => item.id).join(',')
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 验证数据
          if (this.form.couponType === 1 && !this.form.money) {
            this.$message.error('请输入减免金额')
            return
          }
          if (this.form.couponType === 2 && !this.form.discount) {
            this.$message.error('请输入折扣')
            return
          }
          if (this.form.validType === 1) {
            if (!this.form.startTime || !this.form.endTime) {
              this.$message.error('请选择开始时间和结束时间')
              return
            }
            if (this.form.startTime >= this.form.endTime) {
              this.$message.error('结束时间必须大于开始时间')
              return
            }
          }
          if (this.form.validType === 2 && !this.form.validDays) {
            this.$message.error('请输入有效天数')
            return
          }
          if (this.form.rangeType === 2 && !this.form.businessId) {
            this.$message.error('请选择商品分类')
            return
          }
          if (this.form.rangeType === 3 && this.form.goodsList.length === 0) {
            this.$message.error('请选择商品')
            return
          }

          this.submitLoading = true

          const submitData = {
            ...this.form,
            shopIds: this.form.shopIds.join(','),
            needUserLevel: this.form.needUserLevel.join(',')
          }

          const apiMethod = this.formType === 1 ? addCouponType : updateCouponType

          apiMethod(submitData).then(() => {
            this.$message.success(this.formType === 1 ? '新增成功' : '修改成功')
            this.open = false
            this.$emit('ok')
          }).catch(error => {
            console.error('提交失败:', error)
            this.$message.error(error.message || '操作失败')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  text-align: right;
}
</style>
